import { ActionButton } from '@fluentui/react';
import ChatButton from '../../../common/views/ChatButton';
import { Utils } from '../../../common/views/Utils';
import { PaymentUtils } from '../../../payments/views/shared/PaymentUtils';
import { ShortInvoiceModel } from '../../models/InvoiceModel';
import { InvoiceUtils } from '../shared/InvoiceUtils';
import InvoiceOrderListView from './InvoiceOrderListView';

export type InvoiceItemProps = {
    invoice: ShortInvoiceModel;
    onDetail: (invoice: ShortInvoiceModel) => void;
}

export default function InvoiceItemView({ invoice, onDetail }: InvoiceItemProps) {
    const width3 = Utils.getColumnWidth(3);
    const width4 = Utils.getColumnWidth(4);
    const width5 = Utils.getColumnWidth(5);
    const width6 = Utils.getColumnWidth(6);

    const line1 = () => {
        return <div className="ms-Grid-row font-smaller ph-5">
            <div className={width5 + " left font-bold"}>
                {invoice.id}
            </div>
            <div className={width4 + " center"}>
                {Utils.formatShortDate(invoice.date)}
            </div>
            <div className={width3 + " right"}>
                {InvoiceUtils.getStatusText(invoice.status)}
            </div>
        </div>;
    }

    const line2 = () => {
        const balance = invoice.total - invoice.paidAmount;

        return <div className="ms-Grid-row font-smaller ph-5">
            <div className={width3 + " left"} style={{ paddingLeft: 0 }}>
                <ActionButton iconProps={{ iconName: "DeliveryTruck" }}>
                    {invoice.deliveryMethod ?? ""}
                </ActionButton>
            </div>
            <div className={width5 + " center"}>
                <ActionButton iconProps={{ iconName: "PaymentCard" }}>
                    {PaymentUtils.getPaymentRequirementText(invoice.paymentRequirement)}
                </ActionButton>
            </div>
            <div className={width4 + " right font-bold"} style={{ paddingTop: 12 }}>
                ${invoice.total.toFixed(2)} / ${balance.toFixed(2).replace(".00", "")}
            </div>
        </div>;
    }

    const actionRow = () => {
        return <div className="ms-Grid-row default-toolbar">
            <div className={width6 + " left"}>
                <ChatButton />
            </div>

            <div className={width6 + " right"}>
                <ActionButton
                    iconProps={{ iconName: "NumberedListTextMirrored" }}
                    onClick={() => onDetail(invoice)}
                >Detail</ActionButton>
            </div>
        </div>;
    }

    return <div className="ph-15">
        <div className="ms-Grid pt-10 default-border">
            {line1()}

            <div className="pt-15 pb-10">
                <InvoiceOrderListView invoice={invoice} />
            </div>

            {line2()}

            <div className="ms-Grid-row ph-8">
                {actionRow()}
            </div>
        </div>
    </div>;
}